/**
 * Mesajele dintre Roundcube (`infra/webmail/plugins/crm_task`) și pagina „Mail" din CRM.
 *
 * Linkul „Vezi task-ul" dintr-un mail citit în CRM (#2419, 01.11.2026). Roundcube pune
 * `target="_blank"` pe orice link din mail: task-ul pleca, cel mult, spre o filă nouă, iar CRM-ul
 * rămânea pe pagina Mail. Pluginul oprește clicul pe un link spre un task din CRM și trimite paginii
 * Mail doar numărul task-ului; CRM-ul își face singur adresa
 * (`/task-uri?view=<id>`). Din mail nu ajunge nicio adresă în navigarea CRM-ului.
 */
export const MESAJ_MAIL_DESCHIDE_TASK = 'b4l-webmail-deschide-task';
/** Numărul task-ului din mesajul pluginului; `null` pentru orice altceva. */
export function taskDinMesajMail(d) {
    if (!d || typeof d !== 'object')
        return null;
    const { tip, taskId } = d;
    if (tip !== MESAJ_MAIL_DESCHIDE_TASK)
        return null;
    return typeof taskId === 'number' && Number.isSafeInteger(taskId) && taskId > 0 ? taskId : null;
}
/**
 * Sursa mesajului e cadrul cu Roundcube sau un cadru din el, cel mult `adancime` niveluri mai jos.
 * Mailul selectat stă în cadrul de previzualizare al Roundcube, nu în cadrul pus de CRM.
 */
export function dinCadru(sursa, cadru, adancime = 2) {
    if (!sursa || !cadru)
        return false;
    if (sursa === cadru)
        return true;
    if (adancime <= 0)
        return false;
    let n = 0;
    try {
        n = cadru.length;
    }
    catch {
        return false;
    }
    for (let i = 0; i < n; i++) {
        if (dinCadru(sursa, cadru[i], adancime - 1))
            return true;
    }
    return false;
}
//# sourceMappingURL=webmail.js.map